import { Box, List, ListItem, styled } from '@mui/material'

export const StyledCertificatesList = styled(List)(({ theme }) => ({
  padding: theme.spacing(1),
  overflowY: 'auto',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  height: '100%',
}))

export const CertificateListItem = styled(ListItem)<{ approved: boolean }>(({ theme, approved }) => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '8px',
  margin: theme.spacing(1, 0),
  backgroundColor: approved ? '#f0f9f4' : '#fef2f2',
  borderRadius: '8px',
}))

export const QualificationDetailsContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  height: '100%',
}))
